<style>

</style>
<template>
    <div>
        <div class="collapse show">
            <div class="row levels level-main"
                 style="padding-top: 6px;padding-bottom: 6px;padding-left: 4px;background-color: #498cc5;color: white;font-weight: bold;">
                <div class="col-sm-3" style="padding-right:0;padding-left:0;">
                    <i :class="showSection ? 'fa fa-chevron-down item-collapse' : 'fa fa-chevron-right item-collapse'"
                       data-toggle="collapse" @click="toggle" v-show="type != 'ACU'"
                       style="font-size: 11px;padding-top: 3px;float: left;cursor: pointer;"></i>
                    <span class="description" style="padding-left: 3px;width: 185px;white-space: normal;">{{spanDescription}}</span>
                    <i v-if="mainData.type === 'DAS' || mainData.type === 'TOT' || mainData.type === 'TOT2'" class="la la-plus-circle" style="font-size: 18px;float: right;padding-top: 2px;color: green;cursor: pointer;margin-right: 15px;" @click="addSimulation(mainData.type)"></i>
                </div>
                <div class="col-sm-8 mainInfos" style="padding-right:0;padding-left:0;">
                    <div class="row" style="padding-right:0;padding-left:0;">
                        <div class="col-sm-1 text-center" style="padding-right:0;padding-left:0;">&nbsp;
                        </div>

                        <div
                                class="col-sm-2 text-right containerLevelMain containerDate"
                                :data-date="dataValue.date" style="padding-right:0;padding-left:0;"
                                v-show="verifyShowDate(dataValue.date)"
                                v-for="(dataValue, idx) in mainData.data_values" :key="'M-' + idx">
                            <span v-if="mainData.type !== 'ENT' && mainData.type !== 'SAI'">{{dataValue.value | formatNumber}}</span>
                            <span v-else>&nbsp;</span>
                        </div>

                        <div class="col-sm-1 text-center" style="padding-right:0;padding-left:0;">&nbsp;
                        </div>
                    </div>
                </div>
            </div>

            <div v-show="showSection && mainData.type !== 'SLD'" v-if="childName">
                <slot :name="childName"></slot>
            </div>

            <div v-show="mainData.type === 'ENT' || mainData.type === 'SAI'" class="row levels level-main"
                 style="padding-top: 6px;padding-bottom: 6px;padding-left: 4px;background-color: rgb(33 98 154);color: white;font-weight: bold;">

                <div class="col-sm-3" style="padding-right:0;padding-left:0;">
                    <span class="description" style="padding-left: 3px;width: 185px;white-space: normal;">
                      {{ (mainData.type === 'ENT' ? 'Total das entradas' : (mainData.type === 'SAI' ? 'Total das saidas' : '')) }}
                      {{ (mainData.type === 'TOT' || mainData.type === 'TOT2' || mainData.type === 'TOT3' ? spanDescription : '') }}
                    </span>
                </div>
                <div class="col-sm-8 mainInfos" style="padding-right:0;padding-left:0;">
                    <div class="row" style="padding-right:0;padding-left:0;">
                        <div class="col-sm-1 text-center" style="padding-right:0;padding-left:0;">&nbsp;
                        </div>

                        <div
                                class="col-sm-2 text-right containerLevelMain containerDate"
                                :data-date="dataValue.date" style="padding-right:0;padding-left:0;"
                                v-show="verifyShowDate(dataValue.date)"
                                v-for="(dataValue, idx) in mainData.data_values" :key="'M-' + idx">
                            <span>{{dataValue.value | formatNumber}}</span>
                        </div>

                        <div class="col-sm-1 text-center" style="padding-right:0;padding-left:0;">&nbsp;
                        </div>
                    </div>
                </div>
            </div>

            <div v-show="(mainData.type === 'DAS' || mainData.type === 'TOT' || mainData.type === 'TOT2' || mainData.type === 'TOT3') && mainData.simulations" v-for="(simulation, idx) in mainData.simulations" :key="idx" class="row simulation level_three"
                 style="padding-top: 6px;padding-bottom: 6px;color: black;font-weight: bold;">
                <div class="col-sm-3" style="padding-right:0;padding-left:10px;">
                    <input type="text" v-model="simulation.description" class="form-control form-control-sm m-input m-input--solid description" name="simulation_description" />
                </div>
                <div class="col-sm-8 mainInfos" style="padding-right:0;padding-left:0;">
                    <div class="row" style="padding-right:0;padding-left:0;">
                        <div class="col-sm-1 text-center" style="padding-right:0;padding-left:0;">&nbsp;
                        </div>

                        <div
                                class="col-sm-2 text-right containerLevelTwo containerDate"
                                :data-date="dataValue.date" style="padding-right:0;padding-left:0;"
                                v-show="verifyShowDate(dataValue.dateHidden)"
                                v-for="(dataValue, idx) in simulation.data_values" :key="'L2S-' + idx">
                            <v-currency-field
                                v-model="dataValue.value"
                                flat
                                solo
                                reverse
                                dense
                                outilined
                                class="form-control form-control-sm m-input m-input--solid customInput text-right containerLevelThreeSimulation simulationValue value"
                                name="simulation_value"
                                hide-details
                                @focus="$event.target.select()"
                                @keyup="calculateTotal"
                            />
                        </div>

                        <div class="col-sm-1 text-center" style="padding-right:0;padding-left:0;">&nbsp;
                            <i class="la la-check-circle-o" style="font-size: 22px;padding-top: 8px;cursor:pointer;" @click="saveSimulation(simulation, idx)"></i>
                            <i class="la la-trash-o simulation" style="font-size: 22px;padding-top: 8px;cursor:pointer;" @click="removeSimulation(simulation, idx)"></i>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>
</template>


<script>
    export default {
        props: ['typeLevel', 'dataRows', 'cashFlowHiddenDates', 'childName', 'spanDescription', 'type', 'allDates', 'allData'],
        data() {
            return {
                showSection: true,
                description: "",
                mainData: this.dataRows
            }
        },
        watch: {
            dataRows: function (newVal, oldVal) {
                var self = this;
                self.mainData = newVal;
            }
        },
        computed: {
          simulations () {
            const simulations = [];

            for (const it of this.mainData.simulations) {
              const dates = [];

              for (const date of it.data_values) {
                dates.push({
                  dateHidden: date.dateHidden,
                  date: date.date,
                  value: numeral(date.value).format("0,0.00")
                });
              }

              if (dates.length < this.mainData.data_values.length) {
                const count = (this.mainData.data_values.length - dates.length);

                for (let i = dates.length; i <= count; i++) {
                  let newDate = this.mainData.data_values[i].date;
                  let newDateHidden = this.mainData.data_values[i].dateHidden;

                  dates.push({
                    dateHidden: newDateHidden,
                    date: newDate,
                    value: numeral(0).format("0,0.00")
                  });
                }
              }

              simulations.push({
                id: it.id,
                description: it.description,
                data_values: dates
              });
            }

            return simulations;
          }
        },
        methods: {
            toggle() {
                this.showSection = !this.showSection
            },
            calculateTotal () {
              const total = [];
              const objTot = [];

              if (this.allData) {
                for (const data of this.allData) {
                  for (const lvl of data.data_values) {
                    if (data.type === 'ENT' || data.type === 'SAI') {
                      objTot.push({
                        type: data.type,
                        date: lvl.date,
                        value: lvl.value
                      });
                    }
                  }
                }

                // for (const data of this.allData) {
                //   if (data.type === 'ACU2') {
                //     for (const lvl of data.data_values) {
                //       lvl.value = 0;
                //       for (const tot of objTot) {
                //         if (lvl.date === tot.date) {
                //           if (tot.type === 'SAI') {
                //             lvl.value -= tot.value;
                //           } else {
                //             lvl.value += tot.value;
                //           }
                //         }
                //       }
                //     }
                //   }
                // }
              }

              if (this.mainData.data_values) {
                for (const data of this.mainData.data_values) {
                  total.push({
                    date: data.date,
                    value: (data.value ? parseFloat(data.value) : 0)
                  });
                }
              }

              if (this.mainData.simulations) {
                for (const simulation of this.mainData.simulations) {
                  for (const data of simulation.data_values) {
                    total.push({
                      date: data.dateHidden,
                      value: (data.value ? parseFloat(data.value) : 0)
                    });
                  }
                }
              }

              // if (this.mainData.data_values) {
              //   for (const data of this.mainData.data_values) {
              //     if (total) {
              //       data.value = 0;
              //       for (const it of total) {
              //         if (it.date === data.date || it.dateHidden === data.date) {
              //           data.value += parseFloat(it.value);
              //         }
              //       }
              //     }
              //   }
              // }

              this.$emit('recalculeTotal', true);

              // if (this.allData) {
              //   for (const main of this.allData) {
              //     if (main.type === 'ACU2') {
              //       for (const lvl of main.data_values) {
              //         for (const simulation of this.mainData.simulations) {
              //           for (const data of simulation.data_values) {
              //             if (lvl.date === data.date || lvl.date === data.dateHidden) {
              //               lvl.value += parseFloat(data.value);
              //             }
              //           }
              //         }
              //       }
              //     }
              //   }
              // }
            },
            verifyShowDate(dateParam) {
                var self = this;
                var lShow = true;

                for (var i = 0; i < self.cashFlowHiddenDates.length; i++) {
                    if (self.cashFlowHiddenDates[i].dateHidden == dateParam || self.cashFlowHiddenDates[i].dateNoConvert == dateParam) {
                        lShow = false;
                        break;
                    }
                }

                return lShow;

            },
            addSimulation (type) {
                const dates = [];
                let group = null;

                if (type === 'TOT') {
                  group = 1;
                }

                if (type === 'TOT2') {
                  group = 2;
                }

                for (const date of this.allDates) {
                    let newDate = date.dateNoConvert;

                    dates.push({
                        dateHidden: date.dateHidden,
                        date: newDate,
                        value: numeral(0).format("0,0.00")
                    });
                }

                console.log(this.mainData.simulations);
                this.mainData.simulations.push({
                    id: null,
                    description: '',
                    data_values: dates,
                    grouper_iten_id: group
                });
            },
            saveSimulation (simulation, index) {
                const self = this;
                let program = 'addNew';
                let headers = {
                    'token': self.$session.get('token')
                };
                let arrayData = [];
                let arrayDataItens = [];
                let i = 0;
                let j = 0;

                arrayData[i] = {};
                arrayData[i]['cashflow'] = 'J';
                i++;

                if  (simulation.id) {
                    arrayData[i] = {};
                    arrayData[i]['simulation_id'] = simulation.id;
                    i++;

                    program = 'updateIten';
                }

                arrayData[i] = {};
                arrayData[i]['description'] = simulation.description;
                i++;

                arrayData[i] = {};
                arrayData[i]['grouper_iten_id'] = simulation.grouper_iten_id;
                i++;

                for (const date of simulation.data_values) {
                    let newDate = date.date;

                    if (date.date.length === 7 && ($("#periodicity").val() === 'monthly' || $("#periodicity").val() === 'semiannual')) {
                        newDate = date.date + '-01';
                    }

                    if (date.date.length === 4 && $("#periodicity").val() === 'yearly') {
                        newDate = date.date + '-01-01';
                    }

                    arrayDataItens[j] = {};
                    arrayDataItens[j]['date'] = newDate;
                    arrayDataItens[j]['other_date'] = date.dateHidden;
                    arrayDataItens[j]['value'] = numeral().unformat(date.value);
                    j++;
                }

                arrayData[i] = {};
                arrayData[i]['company_id'] = this.companys;
                i++;

                arrayData[i] = {};
                arrayData[i]['itens'] = arrayDataItens;
                i++;

                arrayData[i] = {};
                arrayData[i]['type'] = $("#periodicity").val();

                const params = {
                    arrayData: JSON.stringify(arrayData)
                };

                self.$http.post(self.$store.state.API_BASE + `simulation/${program}`, params, {
                    headers: headers
                }).then(
                    function (result) {
                        showNotification('Sucesso', 'Dados registrados com sucesso!', 'success');
                        console.log(result);
                        unblockPage();
                    },
                    function (error) {
                        unblockPage();
                        showNotification('Atenção', 'Oops! Ocorreu um erro ao salvar os dados.', 'danger');
                        console.log(error);
                    }
                );
            },
            removeSimulation (simulation, index) {
                const self = this;
                let headers = {
                    'token': self.$session.get('token')
                };

                const params = {
                    simulation_id: simulation.id
                };

                self.$http.post(self.$store.state.API_BASE + 'simulation/removeIten', params, {
                    headers: headers
                }).then(
                    function (result) {
                        showNotification('Sucesso', 'Dados registrados com sucesso!', 'success');
                        this.mainData.simulations.splice(index, 1);
                        console.log('deu certo -> ', result);
                        unblockPage();
                        this.calculateTotal();
                    },
                    function (error) {
                        unblockPage();
                        showNotification('Atenção', 'Oops! Ocorreu um erro ao salvar os dados.', 'danger');
                        console.log('deu erro -> ', error);
                    }
                );
            }
        }
    }
</script>

<style scoped>
  .customInput {
    font-size: 14px;
    border-color: #ebedf2;
  }
</style>
